import { FunctionalComponent, h } from 'preact';
import { SearchIcon } from '@uw/icons';
import { useTranslation } from 'services/use-translation';
import { JSXInternal } from 'preact/src/jsx';
import HTMLAttributes = JSXInternal.HTMLAttributes;

interface LanguageSearchProps extends HTMLAttributes<HTMLInputElement> {
  reference: (el: HTMLInputElement) => void;
}

export const LanguageSearch: FunctionalComponent<LanguageSearchProps> = (props) => {
  const { reference, ...otherProps } = props;
  const { translate } = useTranslation();


  return <div className="uwaw-lang-list__search">
    <div className="uwaw-lang-list__search__i">
      <input ref={reference}
             className="uwaw-form-control"
             type="text"
             aria-label={translate('widget.language.search')}
             placeholder={translate('widget.language.search')}
             {...otherProps}
      />
      <span className="uwaw-lang-list__search-ico">
              <SearchIcon width={16} height={16} />
            </span>
    </div>
  </div>;
};
